<template>
  <div class="relative">
    <div class="input-video-bg unselect">
      <div class="video-intext" v-if="video!==''">
        <a :href="video" target="_blank">
          <i class="material-icons input-video-icon unselect after-video-select">videocam</i>
        </a>
        <div class="video-close unselect" @click.stop.prevent="del_video">
          <i class="material-icons">close</i>
        </div>
      </div>

      <input type="file"
             id="input-video"
             class="input-video"
             @input="set_file($event)"
             accept="video/*">
      <label class="video-intext" v-if="video===''" :for="`input-video`">
        <i class="material-icons input-video-icon unselect before-video-select">video_call</i>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: "input-video",
    props: {
      file: {
        type: [String, File],
        required: false
      }
    },
    data() {
      return {
        video: this.file
      }
    },
    watch: {
      file(n) {
        if(n===undefined) this.video = '';
        this.video = n;
      }
    },
    methods: {
      set_file(evt) {
        let maxSize = 1024*1024*500;
        let video = evt.target.files[0];
        console.log(video)
        if(maxSize < video.size) {
          this.toast('300MB 이하로 선택하세요.');
          return;
        }
        this.video = video;
        this.$emit('update:file', video);
      },
      del_video() {
        this.video = '';
        this.$emit('update:file', '');
      }
      /*onUploadFile(evt){
        console.log(evt.target);
        this.file = evt.target.files[0];
        let formData = new FormData();
        formData.append('f', this.file)
        this.$axios.post('public/upload/video', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
          .then(res => {
            console.log('uploaded');
            this.video.url = res.data.url;
          });
      },
      updateFile(evt){
        console.log(evt.target);
        this.file = evt.target.files[0];
        let formData = new FormData();
        formData.append('f', this.file)
        this.$axios.post('public/update/video', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
          .then(res => {
            console.log('uploaded');
            this.video.url = res.data.url;
          });
      }*/
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

  $input-video-size = 80px
  .input-video-bg
    width $input-video-size
    height $input-video-size
    background-color white
    border 1px solid #dbdbdb
    border-radius 4px
    box-shadow inset 0 1px 2px rgba(10,10,10,0.1)
    display flex
    position relative
    margin-right 10px
    margin-bottom 10px
    flex-shrink 0


  .input-video
    width $input-video-size
    height $input-video-size
    position fixed
    top -100px
    left -100px

  .video-intext
    width 100%
    /*color #797979*/
    position absolute
    top 0
    left 0
    height 100%
    display flex
    justify-content center
    align-items center

    > .video-close
      padding 2px 4px
      font-size 14px
      color #555
      position absolute
      top 0
      right 0
      margin -2px
      line-height 13px

  .input-video-icon
    font-size 45px

  .before-video-select
    color #797979
</style>
